// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NsDrawer__container{position:fixed;top:0;bottom:0;right:0;left:0;visibility:hidden;transition-property:visibility;touch-action:pan-y;z-index:900}.NsDrawer__scrim{position:absolute;top:0;right:0;bottom:0;left:0;transition-property:opacity;transform:translateZ(0);opacity:0;background:rgba(0,0,0,.5)}.NsDrawer__content{position:absolute;top:0;bottom:0;left:0;width:256px;transition-property:transform;transform:translate3d(-100%, 0, 0);background-color:#fff}", ""]);
// Exports
exports.locals = {
	"container": "NsDrawer__container",
	"scrim": "NsDrawer__scrim",
	"content": "NsDrawer__content"
};
module.exports = exports;
